import { Component, ViewEncapsulation } from '@angular/core';
import { MapStoreService } from '@app/energy-map/services/map-store.service';
import { SidebarComponent } from '@app/shared/components/sidebar/sidebar.component';
import { ApplicationInsightEvent } from '@app/shared/enums';
import { AppInsightsServiceDirective } from '@app/shared/services/app-insights.service';
import { SidebarService } from '@app/shared/services/sidebar.service';
import { isNil } from 'lodash';
import { LampsSelectedService } from '../../services/lamps-selected.service';
import { MapService } from '../../services/map.service';

@Component({
  selector: 'app-street-light-planner-sidebar-new',
  templateUrl: './street-light-planner-sidebar-new-scenario.component.html',
  styleUrls: ['./street-light-planner-sidebar-new-scenario.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class StreetLightPlannerSidebarNewScenarioComponent extends SidebarComponent {
  private readonly minStep = 1;
  private customBack: Function | null = null;
  private customNext: Function | null = null;

  public scenario: any = {
    isBudget: true,
    budget: 0,
    recommendationTypeId: null,
    isRecommendation: null,
  };
  public maxStep = 3;
  public step = 1;
  public isRecommendation: boolean | null = null;
  public isLoading = false;

  constructor(
    public sidebarService: SidebarService,
    private appInsightsServiceDirective: AppInsightsServiceDirective,
    private lampsSelectedService: LampsSelectedService,
    private mapService: MapService,
    private mapStoreService: MapStoreService
  ) {
    super(sidebarService);
  }

  onRecommendationChange(value: boolean) {
    this.isRecommendation = value;
  }

  back() {
    if (this.step === this.minStep) {
      this.triggerClose();
    }

    if (!isNil(this.customBack)) {
      this.customBack();
    }
  }

  triggerClose() {
    this.appInsightsServiceDirective.logEvent(ApplicationInsightEvent.streetlightPlannerCancel);
    this.mapService.selectMode(false);
    if (this.mapStoreService.lampMarkers.length !== 0 || !this.mapStoreService.streetLightCluster || !this.mapStoreService.streetLightHeatmap) {
      this.mapService.resetLampsIcon();
      this.lampsSelectedService.resetLamps();
      (this.mapStoreService.map as L.Map).closePopup();
    }

    this.close();
  }

  next() {
    this.scenario.isRecommendation = this.isRecommendation;

    if (!isNil(this.customNext)) {
      this.customNext();
    }
  }

  updateMaxStep(value: number) {
    this.maxStep = value;
  }

  updateStep(value: number) {
    this.step = value;
  }

  updateBack(value: Function) {
    this.customBack = value;
  }

  updateNext(value: Function) {
    this.customNext = value;
  }

  reset() {
    this.customBack = null;
    this.customNext = null;
    this.step = this.minStep;
    this.isRecommendation = null;
    this.scenario = {
      isBudget: true,
      budget: 0,
      recommendationTypeId: null,
      isRecommendation: null,
    };
    this.mapService.resetLampsIcon();
    this.lampsSelectedService.resetLamps();
    this.mapService.selectMode(false);
  }
}
